var _path, _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapAndLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 507,
    height: 233,
    viewBox: "0 0 507 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.12 100.413C282.12 120.436 268.197 137.218 249.474 141.669C246.293 142.426 241.108 145.911 238.786 152.08C236.465 145.911 232.827 142.426 229.646 141.669C210.922 137.218 197 120.436 197 100.413C197 76.989 216.055 58 239.56 58C263.065 58 282.12 76.989 282.12 100.413Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 203.72,
    y: 64.7188,
    width: 71.6799,
    height: 71.6799,
    rx: 35.8399,
    fill: "#337BBB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2367_14489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.64 89.91C221.806 89.0488 222.483 88.5738 223.09 88.0424C226.103 85.4115 229.386 83.2197 233.26 81.989C238.101 80.4493 242.86 80.7339 247.531 82.658C250.599 83.9226 253.223 85.8506 255.768 87.9274C256.968 88.9055 257.376 89.9892 257.336 91.478C257.196 96.476 255.931 101.15 253.499 105.533C251.477 109.18 248.905 112.414 245.831 115.239C244.121 116.813 242.258 118.226 240.441 119.685C239.74 120.247 239.289 120.26 238.58 119.711C236.827 118.353 235.061 117.001 233.382 115.556C230.822 113.351 228.673 110.778 226.82 107.976C224.137 103.924 222.431 99.5121 221.835 94.7007C221.758 94.0788 221.705 93.455 221.64 92.8331V89.91ZM225.526 94.0675C225.509 94.3031 225.477 94.4538 225.49 94.6008C225.565 95.349 225.611 96.1029 225.741 96.8435C226.688 102.224 229.408 106.698 233.118 110.65C234.768 112.409 236.631 113.935 238.619 115.318C239.358 115.833 239.468 115.839 240.236 115.35C242.879 113.675 245.095 111.54 247.113 109.191C250.202 105.598 252.347 101.548 253.202 96.8869C253.367 95.9879 253.426 95.0682 253.549 94.0449C253.265 94.1466 253.119 94.1881 252.981 94.2484C251.885 94.7214 250.802 95.2265 249.691 95.6619C249.196 95.856 248.97 96.1462 248.878 96.6456C248.554 98.4209 247.904 100.096 247.076 101.694C245.323 105.089 242.856 107.921 239.914 110.373C239.577 110.656 239.31 110.652 239.006 110.351C237.781 109.139 236.482 107.995 235.337 106.713C232.691 103.751 230.812 100.377 230.04 96.4666C229.965 96.084 229.766 95.8654 229.408 95.7184C228.626 95.3999 227.857 95.0512 227.083 94.7196C226.592 94.5085 226.098 94.3031 225.53 94.0656L225.526 94.0675ZM237.264 97.1149C237.264 99.4556 237.269 101.796 237.258 104.137C237.258 104.51 237.369 104.795 237.645 105.053C238.155 105.528 238.653 106.016 239.123 106.53C239.387 106.819 239.586 106.8 239.832 106.542C240.246 106.106 240.635 105.641 241.091 105.251C241.599 104.817 241.75 104.307 241.748 103.668C241.733 99.1427 241.739 94.6197 241.741 90.0947C241.741 89.4087 241.806 89.3616 242.494 89.518C244.788 90.0363 246.852 91.0314 248.719 92.4279C249.054 92.6785 249.351 92.7841 249.765 92.5881C250.727 92.1301 251.713 91.7193 252.682 91.2707C253.315 90.9786 253.326 90.8618 252.83 90.3774C251.619 89.1958 250.227 88.2516 248.744 87.4374C246.241 86.0654 243.565 85.2117 240.698 85.0364C237.582 84.8442 234.586 85.3813 231.748 86.6685C229.618 87.6334 227.646 88.8452 225.99 90.5056C225.611 90.8863 225.63 90.988 226.117 91.2104C227.073 91.6476 228.053 92.0359 228.988 92.5089C229.513 92.7727 229.883 92.6842 230.327 92.3468C232.162 90.9541 234.23 90.0288 236.485 89.5199C237.191 89.3616 237.26 89.4257 237.26 90.1418C237.26 92.4674 237.26 94.7912 237.26 97.1168L237.264 97.1149Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.562 87.0781L361.77 99.7806C364.756 101.347 366.249 102.131 367.764 102.663C372.14 104.198 376.888 104.312 381.332 102.987C382.871 102.529 384.4 101.818 387.457 100.396V100.396",
    stroke: "#E3E4E6",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M284.751 113.492L360.21 148.75",
    stroke: "#E3E4E6",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.925 36.8048L300.571 11.3924C306.971 8.04919 310.171 6.37757 313.58 5.79399C315.631 5.44287 317.721 5.38445 319.788 5.62046C323.224 6.01274 326.512 7.50301 333.089 10.4835V10.4835C339.242 13.2719 342.318 14.6661 345.542 15.0941C347.483 15.3518 349.45 15.3492 351.39 15.0864C354.613 14.6499 357.685 13.2476 363.831 10.443L384.522 1",
    stroke: "#E3E4E6",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.242 157.477L268.92 163.201C275.562 166.199 283.127 166.417 289.93 163.806V163.806C296.052 161.456 302.815 161.389 308.983 163.617L309.475 163.795C316.72 166.412 324.713 166.007 331.656 162.67L347.905 154.86C362.408 147.891 369.659 144.406 377.435 144.322C385.21 144.238 392.535 147.566 407.184 154.222L417.81 159.051C433.165 166.027 440.842 169.516 448.963 169.275C457.084 169.033 464.54 165.096 479.454 157.22L505.675 143.374",
    stroke: "#E3E4E6",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.383 159.496L220.936 161.222C216.053 163.666 213.611 164.889 211.112 165.527C206.688 166.656 202.034 166.501 197.695 165.078C195.244 164.274 192.889 162.891 188.181 160.125V160.125C183.673 157.477 181.419 156.153 179.068 155.361C174.908 153.959 170.443 153.724 166.159 154.683C163.738 155.226 161.358 156.306 156.598 158.468L25.6748 217.924",
    stroke: "#E3E4E6",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M97.7793 85.9541L146.293 62.4029C156.41 57.4915 161.469 55.0358 166.893 54.996C166.939 54.9957 166.984 54.9954 167.03 54.9954C172.455 54.9864 177.535 57.3964 187.696 62.2166V62.2166C198.654 67.4148 204.133 70.0139 209.947 69.8237C209.996 69.8222 210.045 69.8204 210.093 69.8185C215.907 69.593 221.186 66.6094 231.745 60.6421L263.95 42.4414",
    stroke: "#E3E4E6",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.803 145.724L57.1172 68.1562",
    stroke: "#E3E4E6",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.566 146.061L265.656 140.769C267.261 140.003 268.064 139.62 268.506 139.213C270.123 137.727 270.238 135.214 268.765 133.586C268.362 133.14 267.598 132.685 266.07 131.775V131.775C264.55 130.87 263.791 130.417 263.388 129.973C261.917 128.349 262.026 125.845 263.632 124.355C264.072 123.947 264.868 123.562 266.461 122.792L282.235 115.168",
    stroke: "#E3E4E6",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.568 146.07L265.573 140.819C267.251 140.018 268.091 139.617 268.548 139.185C270.113 137.706 270.226 135.253 268.803 133.636C268.388 133.163 267.589 132.688 265.991 131.736V131.736C264.429 130.806 263.647 130.34 263.235 129.874C261.822 128.28 261.908 125.858 263.428 124.366C263.873 123.93 264.685 123.521 266.309 122.703L332.279 89.4504C338.633 86.248 341.809 84.6468 341.78 82.1509C341.75 79.655 338.536 78.1297 332.109 75.0792L179.195 2.50781",
    stroke: "#E3E4E6",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.015 152.777C258.015 154.373 256.637 156.378 253.118 158.104C249.729 159.766 244.908 160.851 239.473 160.851C234.039 160.851 229.217 159.766 225.829 158.104C222.309 156.378 220.932 154.373 220.932 152.777C220.932 151.181 222.309 149.175 225.829 147.449C229.217 145.788 234.039 144.703 239.473 144.703C244.908 144.703 249.729 145.788 253.118 147.449C256.637 149.175 258.015 151.181 258.015 152.777Z",
    stroke: "#E3E4E6",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2367_14489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.015 152.777C258.015 154.373 256.637 156.378 253.118 158.104C249.729 159.766 244.908 160.851 239.473 160.851C234.039 160.851 229.217 159.766 225.829 158.104C222.309 156.378 220.932 154.373 220.932 152.777C220.932 151.181 222.309 149.175 225.829 147.449C229.217 145.788 234.039 144.703 239.473 144.703C244.908 144.703 249.729 145.788 253.118 147.449C256.637 149.175 258.015 151.181 258.015 152.777Z",
    stroke: "#E3E4E6",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.5248,
    cy: 186.022,
    rx: 6.70744,
    ry: 3.69369,
    fill: "#E3E4E6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2367_14489)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.5248,
    cy: 186.022,
    rx: 6.70744,
    ry: 3.69369,
    fill: "#E3E4E6"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 285.601,
    cy: 52.3187,
    rx: 6.70744,
    ry: 3.6937,
    fill: "#E3E4E6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2367_14489)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 285.601,
    cy: 52.3187,
    rx: 6.70744,
    ry: 3.6937,
    fill: "#E3E4E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-1_2367_14489",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 285.164,
    cy: 52.6667,
    rx: 7.38584,
    ry: 3.94404
  })), /*#__PURE__*/React.createElement("path", {
    d: "M288.55 52.6667C288.55 52.1424 288.761 51.8099 288.834 51.7183C288.886 51.6525 288.824 51.7557 288.503 51.9271C287.853 52.2742 286.679 52.6107 285.164 52.6107V60.6107C287.728 60.6107 290.248 60.0644 292.271 58.984C294.123 57.9947 296.55 55.9496 296.55 52.6667H288.55ZM285.164 52.6107C283.649 52.6107 282.476 52.2742 281.826 51.9271C281.505 51.7557 281.442 51.6525 281.494 51.7183C281.567 51.8099 281.778 52.1424 281.778 52.6667H273.778C273.778 55.9496 276.205 57.9947 278.057 58.984C280.081 60.0644 282.6 60.6107 285.164 60.6107V52.6107ZM281.778 52.6667C281.778 53.191 281.567 53.5235 281.494 53.6151C281.442 53.6809 281.505 53.5777 281.826 53.4063C282.476 53.0592 283.649 52.7227 285.164 52.7227V44.7227C282.6 44.7227 280.081 45.269 278.057 46.3494C276.205 47.3386 273.778 49.3837 273.778 52.6667H281.778ZM285.164 52.7227C286.679 52.7227 287.853 53.0592 288.503 53.4063C288.824 53.5777 288.886 53.6809 288.834 53.6151C288.761 53.5235 288.55 53.191 288.55 52.6667H296.55C296.55 49.3837 294.123 47.3386 292.271 46.3494C290.248 45.269 287.728 44.7227 285.164 44.7227V52.7227Z",
    fill: "#E3E4E6",
    mask: "url(#path-19-inside-1_2367_14489)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2367_14489",
    x: 214.932,
    y: 138.703,
    width: 49.083,
    height: 28.1484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2367_14489"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2367_14489",
    x: 85.8174,
    y: 178.328,
    width: 21.415,
    height: 15.3867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2367_14489"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2367_14489",
    x: 274.894,
    y: 44.625,
    width: 21.415,
    height: 15.3867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2367_14489"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2367_14489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.8399,
    height: 39.1999,
    fill: "white",
    transform: "translate(221.64 80.957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapAndLogo);
export default __webpack_public_path__ + "static/media/map-and-logo.520d3322baecca9b9e3621b0c63fafc7.svg";
export { ForwardRef as ReactComponent };